module.exports = __webpack_public_path__ + "static/media/layout5-img.67e0a068.svg";